/**
 * Funciones de cálculo reutilizables
 */

/**
 * Calcula el saldo de suma asegurada restando los importes de estudios de clínicas
 * @param {number|string} suma_asegurada - Suma asegurada total
 * @param {Array} clinicas - Array de clínicas con estudios
 * @returns {number} Saldo restante de suma asegurada
 */
export const calcularSaldoSumaAsegudara = (suma_asegurada, clinicas = []) => {
  let importe_parcial = [];

  clinicas.forEach((clinica) => {
    if (clinica.estudios && Array.isArray(clinica.estudios)) {
      clinica.estudios.forEach((estudio) => {
        importe_parcial.push(
          estudio.importe === "" || estudio.importe === null ? 0 : parseInt(estudio.importe)
        );
      });
    }
  });

  const sum = importe_parcial.reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);

  return suma_asegurada === "" || suma_asegurada === null ? sum : suma_asegurada - sum;
};
